import { useEffect, useState } from "react";

/**
 * Returns a "current epoch ms" value that re-renders the consumer on a fixed
 * cadence and whenever the window/tab regains focus or visibility. Used for
 * lightweight countdowns (card hand, active-effect banners) where ticking
 * every 30s + on focus is good enough.
 */
export function useNowTicker(intervalMs: number = 30_000): number {
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    const tick = () => setNow(Date.now());
    const timer = window.setInterval(tick, intervalMs);
    const onFocus = () => tick();
    const onVisibility = () => {
      if (document.visibilityState === "visible") tick();
    };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [intervalMs]);

  return now;
}
